<template>
  <div class="info-region-container" style="margin-right: 30px; overflow-x: none; width: 100%; height: 100vh" v-allow="'0902'">
    <div v-loading="isLoading" :element-loading-text="'当前调控数据下发中，请勿点击其它操作，耐心等待'" class="all-content-container">
      <div class="info-title-container container-user">
        <div class="title_muen">
          <!-- <h4 v-if="activeName == 0">灯光</h4>
          <h4 v-if="activeName == 1">滴灌</h4>
          <h4 v-if="activeName == 2">外风机</h4>
          <h4 v-if="activeName == 3">内风机</h4> -->
          <!-- <el-button type="primary" class="adduser" @click="add">添加</el-button> -->
        </div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <!-- <el-form-item label="组织结构:">
            <el-cascader @change="changeTreeItem" :show-all-levels="false" v-model="formInline.organization" :options="departList" :props="optionProps" clearable placeholder="组织结构"></el-cascader>
          </el-form-item> -->
          <div class="a96">
            <!-- <el-button type="primary" @click="openAddit_">新增配置</el-button> -->
            <div>
              <el-button type="primary" v-if="table.length > 0 && showType" @click="showType = !showType">设备调控组件</el-button>
              <el-button type="primary" v-if="table.length > 0 && !showType" @click="showType = !showType">返回</el-button>
              <el-button type="primary" v-if="table.length > 0 && !showType" @click="openModel">调控组件下发</el-button>
              <el-button type="primary" v-if="table.length > 0 && !showType" @click="openHisList">调控组件下发记录</el-button>
              <el-button type="primary" v-if="showType" @click="openCmdTaskList">历史报文下发记录</el-button>
              <el-button type="primary" v-if="table.length > 0 && !showType" @click="openCmdTaskList1">历史报文下发记录</el-button>

              <el-button type="primary" v-if="activeName == 0 && showType" @click="handleSaveExtend_A(activeName)">光照强度定时任务下发</el-button>
              <el-button type="primary" v-if="activeName == 1 && showType" @click="handleSaveExtend_A(activeName)">土壤湿度定时任务下发</el-button>
              <el-button type="primary" v-if="activeName == 2 && showType" @click="handleSaveExtend_A(activeName)">Co2浓度定时任务下发</el-button>
              <el-button type="primary" v-if="activeName == 3 && showType" @click="handleSaveExtend_A(activeName)">内风机定时任务下发</el-button>
              <el-button type="primary" v-if="activeName == 4 && showType" @click="handleSaveExtend_A(activeName)">空气温度定时任务下发</el-button>
              <el-button type="primary" v-if="activeName == 5 && showType" @click="handleSaveExtend_A(activeName)">空气湿度定时任务下发</el-button>

              <el-button type="primary" v-if="showType" @click="openTimeTask_1">下发记录查询</el-button>
              <el-button type="primary" v-if="showType" style="margin-left: 10px" @click="handleImport">导入</el-button>
              <el-button type="primary" v-if="showType" @click="excel">导出</el-button>
            </div>
          </div>
        </el-form>
      </div>
      <div class="info-content-container">
        <div class="table_content1">
          <el-table v-if="showType" :data="tableData" align="center" v-loading="loading" :header-cell-style="{ background: '#f4f5f7' }">
            <el-table-column prop="orderNum" align="center" label="定时分组" width></el-table-column>
            <!-- <el-table-column align="center" label="执行星期" width>
              <template slot-scope="scope">
                <span v-if="scope.row.weekTime==1">星期一</span>
                <span v-if="scope.row.weekTime==2">星期二</span>
                <span v-if="scope.row.weekTime==3">星期三</span>
                <span v-if="scope.row.weekTime==4">星期四</span>
                <span v-if="scope.row.weekTime==5">星期五</span>
                <span v-if="scope.row.weekTime==6">星期六</span>
                <span v-if="scope.row.weekTime==7">星期七</span>
              </template>
            </el-table-column> -->
            <el-table-column prop="startTime" align="center" label="开始时间" width></el-table-column>
            <el-table-column prop="endTime" align="center" label="结束时间" width></el-table-column>
            <el-table-column prop="intervalTime" align="center" label="间隔天数" width></el-table-column>

            <el-table-column align="center" label="启用状态" width>
              <template slot-scope="scope">
                <span v-if="scope.row.status == 0">已禁用</span>
                <span v-if="scope.row.status == 1">已启用</span>
              </template>
            </el-table-column>

            <el-table-column align="center" label="操作" width="260">
              <template slot-scope="scope">
                <el-button v-if="scope.row.status == 0" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">启用</el-button>
                <el-button style="color: red" v-if="scope.row.status == 1" @click="updateGrowthModelDecisionScheduleStatus(scope.row.id)" type="text" size="small">禁用</el-button>
                <el-button @click="updatabox(scope.row.id)" type="text" size="small">编辑</el-button>
                <!-- <el-button style="color:red" type="text" size="small" @click="delModelAlarmSettings(scope.row.id)">删除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          <el-table v-else :data="table" align="center" v-loading="loading" :header-cell-style="{ background: '#f4f5f7' }">
            <el-table-column prop="index" align="center" label="定时分组" width="70px"></el-table-column>
            <el-table-column v-for="(item, index) in tableData_list" :key="index" align="center" :label="item.label" width>
              <template slot-scope="scope">
                <el-switch @change="getMore(scope.row[index], index, item.id)" v-model="scope.row[index]" active-color="#13ce66" inactive-color="#ff4949" active-value="1" inactive-value="0"> </el-switch>
                <!-- <span @click="getMore(scope.row[index],index,item.id)" v-if="scope.row[index] == 0">已禁用</span>
                <span v-if="scope.row[index] == 1">已启用</span> -->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog title="定时任务配置" :visible.sync="extendIsDialog_" width="600px" center style="z-index: 10000">
          <el-form ref="ruleFormExtend" :rules="rulesExtend" :model="ruleFormTime" label-width="120px" class="demo-ruleForm">
            <el-row>
              <el-col :span="24">
                <el-form-item label="定时分组：">
                  <el-input-number size="small" v-model="ruleFormTime.orderNum" :min="1" :max="100" label="定时分组"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="定时范围：" prop="time">
                  <el-time-picker is-range v-model="ruleFormTime.time" range-separator="至" start-placeholder="开启时间" value-format="HH:mm" format="HH:mm" end-placeholder="关闭时间" placeholder="选择时间范围"> </el-time-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="间隔天数：" prop="intervalTime">
                  <el-input v-model="ruleFormTime.intervalTime" placeholder="请输入间隔天数"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="22">
                <el-form-item label="执行星期：" prop="weekTime">
                  <el-select v-model="ruleFormTime.weekTime" clearable placeholder="请选择执行星期">
                    <el-option label="星期一" value="1"></el-option>
                    <el-option label="星期二" value="2"></el-option>
                    <el-option label="星期三" value="3"></el-option>
                    <el-option label="星期四" value="4"></el-option>
                    <el-option label="星期五" value="5"></el-option>
                    <el-option label="星期六" value="6"></el-option>
                    <el-option label="星期七" value="7"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row> -->
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancelExtend">取 消</el-button>
            <el-button type="primary" @click="handleSaveExtend_Time">确 定</el-button>
          </div>
        </el-dialog>
        <el-dialog :title="cs_name" :visible.sync="TimingTaskRecording" :before-close="handclose_99" width="1100px" center style="z-index: 10000">
          <el-col :span="14">
            <div class="flex" style="margin: 10px">
              <div class="titii">操作时间：</div>
              <el-date-picker v-model="searchFormTimingTaskRecording.time" type="datetimerange" :picker-options="pickerOptions" @change="getTime_1" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" style="margin: 7px">
            <el-button type="primary" class="status_open a33" @click="getGrowthModelDecisionScheduleHisDataSendList"> 查询 </el-button>
            <el-button type="primary" class="status_open a33" @click="reasta13"> 重置 </el-button>
          </el-col>
          <div class="table_content1" style="margin-top: 10px">
            <el-table :data="TimingTaskRecordingtableData" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <el-table-column prop="orderNum" align="center" label="定时分组" width="70px"></el-table-column>
              <!-- <el-table-column align="center" label="执行星期" width>
                <template slot-scope="scope">
                  <span v-if="scope.row.weekTime==1">星期一</span>
                  <span v-if="scope.row.weekTime==2">星期二</span>
                  <span v-if="scope.row.weekTime==3">星期三</span>
                  <span v-if="scope.row.weekTime==4">星期四</span>
                  <span v-if="scope.row.weekTime==5">星期五</span>
                  <span v-if="scope.row.weekTime==6">星期六</span>
                  <span v-if="scope.row.weekTime==7">星期七</span>
                </template>
              </el-table-column> -->

              <el-table-column prop="startTime" align="center" label="开启时间" width></el-table-column>
              <el-table-column prop="endTime" align="center" label="关闭时间" width></el-table-column>
              <el-table-column prop="intervalTime" align="center" label="间隔时间" width></el-table-column>

              <el-table-column align="center" label="状态" width>
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">已禁用</span>
                  <span v-if="scope.row.status == 1">已启用</span>
                </template>
              </el-table-column>
              <el-table-column prop="realName" align="center" label="下发人" width></el-table-column>
              <el-table-column prop="updateTime" align="center" label="下发时间" width="250"></el-table-column>
            </el-table>
          </div>
          <div class="pagination-container">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_2" :current-page="searchFormTimingTaskRecording.pageNum" :page-size="searchFormTimingTaskRecording.pageSize" :total="searchFormTimingTaskRecording.total"></el-pagination>
            </div>
          </div>
          <!-- <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="handclose_99">确 定</el-button>
          </div> -->
        </el-dialog>
        <el-dialog title="调控组件下发记录" :visible.sync="hisRecording" :before-close="handclose_his" width="1200px" center style="z-index: 10000">
          <el-col :span="14">
            <div class="flex" style="margin: 10px">
              <div class="titii">下发时间：</div>
              <el-date-picker v-model="his.time" type="datetimerange" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"> </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" style="margin: 7px">
            <el-button type="primary" class="status_open a33" @click="searchHis"> 查询 </el-button>
            <el-button type="primary" class="status_open a33" @click="reastaHis"> 重置 </el-button>
          </el-col>
          <div v-if="hisLits.length > 0" class="table_content1" style="margin-top: 10px">
            <el-table :data="hisLits" align="center" class="data-table" style="width: 100%" v-loading="loading" :header-cell-style="{ background: '#F4F5F7' }">
              <!-- <el-table-column prop="orderNum" align="center" label="定时分组" width="70px"></el-table-column> -->
              <el-table-column prop="name" align="center" label="组件名称" width></el-table-column>

              <el-table-column v-for="(item, index) in hisLits[0].arr" :key="index" align="center" :label="`第${index + 1}组`" width>
                <template slot-scope="scope">
                  <span v-if="scope.row[index] == 0">已禁用</span>
                  <span v-if="scope.row[index] == 1">已启用</span>
                </template>
              </el-table-column>
              <el-table-column prop="updateTime" align="center" label="下发时间" width="150"></el-table-column>
            </el-table>
          </div>
          <div class="pagination-container">
            <div class="page"></div>
            <div class="pagination-content-container">
              <el-pagination background layout="prev, pager, next, jumper" class="pageTap" @current-change="handleCurrentChange_his" :current-page="his.pageNum" :page-size="his.pageSize" :total="his.total"></el-pagination>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-dialog title="导入模板" :visible.sync="importDialog" width="500px" :before-close="handleCloseImport">
      <div class="equipmentcenter-opption-box">
        <el-form ref="importForm" label-width="0px">
          <el-form-item label="" style="width: 100%">
            <el-upload class="upload-demo" :action="$serverUrl + '/pc/growthModelDecisionSchedule/importGrowthModelDecisionSchedules'" :data="{ decisionId: value, type: activeName }" :headers="headers" name="fileName" :before-upload="handleChange" :on-success="handleAvatarSuccess" :limit="1" :file-list="importFileList">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传excel（.xls和.xlsx）文件</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <Info ref="info"></Info>
  </div>
</template>
<script>
import moment from 'moment'
import Info from './info.vue'
export default {
  name: 'userManagementone',
  components: {
    Info
  },
  props: {
    tableData: {},
    activeName: {},
    value: {},
    devicId_: {},
    table: {},
    tableData_list: {}
  },
  data() {
    return {
      showType: true,
      pwd: '',
      isLoading: false,
      importFileList: [],
      headers: {
        // 请求头
        AUTHORIZATION: sessionStorage.getItem('TOKEN')
      },
      importDialog: false,

      optionProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        expandTrigger: 'hover',
        checkStrictly: true
      },
      extendIsDialog_: false,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 3)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近五天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 5)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      dialogTitle: '',
      pagesize: 8,
      currentPage: 1,
      total: 0,
      loading: false, //加载
      centerDialogVisible: false, //添加弹框
      email: '',
      qq: '',
      status: '',
      allSysRoleList: [], //全部角色

      genderList: [
        {
          value: '0',
          name: '男'
        },
        {
          value: '1',
          name: '女'
        }
      ],

      formInline: {
        //查询条件（参数）
        user: '',
        role: '',
        nink: '',
        organization: ''
      },
      dialogformInline: {
        //添加参数或者编辑参数
        username: '', //账号
        role: '', // 角色
        nink: '', // 昵称
        departId: '', // 组织机构
        password: '', //密码
        realName: '', //姓名
        gender: '', //性别
        mobile: '', //手机号
        email: '', //邮箱
        qq: '',
        roleID: ''
      },
      dialogRules: {
        // 弹框表单验证
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        nink: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        role: [{ required: true, message: '请选择角色', trigger: 'change' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^[\w_-]{6,40}$/, //正则
            message: '请输入（长度为6~18位的密码）'
          }
        ],
        departId: [{ required: true, message: '请选择组织机构', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        nink: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        mobile: [
          { required: false, message: '请输入手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/, //正则
            message: '请输入正确的手机号'
          }
        ],
        qq: [
          { required: false, message: '请输入QQ', trigger: 'blur' },
          {
            pattern: /^[1-9][0-9]{4,9}$/, //正则
            message: '请输入正确的QQ'
          }
        ],
        email: [
          { required: false, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, //正则
            message: '请输入正确的邮箱'
          }
        ]
      },

      departList: [],
      searchId: '',
      ruleFormTime: {
        decisionId: '',
        endTime: '',
        orderNum: '',
        startTime: '',
        type: '',
        weekTime: '',
        id: '',
        time: ''
      },
      TimingTaskRecordingtableData: [],
      searchFormTimingTaskRecording: {
        id: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      },
      cs_name: '',
      hisRecording: false,
      his: {
        decisionId: '',
        pageNum: 1,
        pageSize: 10,
        total: 1,
        time: '',
        endTime: '',
        startTime: '',
        type: ''
      },
      hisLits: []
    }
  },

  created() {
    this.init()
  },
  methods: {
    openCmdTaskList() {
      this.$refs.info.searchFormTimingTaskRecording.decisionId = this.value
      this.$refs.info.searchFormTimingTaskRecording.type = this.activeName
      this.$refs.info.searchFormTimingTaskRecording.taskType = 2
      this.$refs.info.openTimeTask_1()
    },
    openCmdTaskList1() {
      this.$refs.info.searchFormTimingTaskRecording.decisionId = this.value
      this.$refs.info.searchFormTimingTaskRecording.type = this.activeName
      this.$refs.info.searchFormTimingTaskRecording.taskType = 3
      this.$refs.info.openTimeTask_1()
    },
    handclose_his() {
      this.hisRecording = false
    },
    searchHis() {
      this.his.pageNum = 1
      this.getGrowthModelDecisionScheduleComponetsDataHisList()
    },
    reastaHis() {
      this.his.time = []
      this.his.pageNum = 1
      this.getGrowthModelDecisionScheduleComponetsDataHisList()
    },

    handleCurrentChange_his(currentPage) {
      this.his.pageNum = currentPage
      this.getGrowthModelDecisionScheduleComponetsDataHisList()
    },
    openHisList() {
      this.hisRecording = true
      this.getGrowthModelDecisionScheduleComponetsDataHisList()
    },
    getGrowthModelDecisionScheduleComponetsDataHisList() {
      this.his.decisionId = this.value
      this.his.type = this.activeName
      this.his.startTime = this.his.time[0]
      this.his.endTime = this.his.time[1]
      this.$api.growthModel.getGrowthModelDecisionScheduleComponetsDataHisList(this.his).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.arr = []
            item.deviceStatus.split(',').map((citem, index) => {
              item[index] = citem
              item.arr.push(item[index])
            })
          })
          this.hisLits = res.data
          this.his.total = res.count
        }
      })
    },
    openModel() {
      this.isLoading = true

      this.$api.growthModel.sendGrowthModelDecisionScheduleComponets({ decisionId: this.value, type: this.activeName }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.isLoading = false
          that.$parent.$parent.$parent.getGrowthModelDecisionScheduleComponets()
        }
      })
    },
    getMore(row, index, id) {
      console.log(this.table)
      console.log(row, index, id)
      let arr = []
      this.table.map(item => {
        arr.push(item[index])
      })
      console.log(arr)
      let form = {
        deviceStatus: arr.join(','),
        id: id
      }
      var that = this
      this.$api.growthModel.saveGrowthModelDecisionScheduleComponets(form).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          that.$parent.$parent.$parent.getGrowthModelDecisionScheduleComponets()
        }
      })
    },
    // 导入
    handleImport() {
      this.$confirm('导入数据会对现有数据进行覆盖，是否继续导入？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.importDialog = true
        })
        .catch(() => {
          this.$message.info('已取消导入')
        })
    },
    // 上传成功
    handleAvatarSuccess(res, file) {
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: res.msg
        })
        // 重新获取生长模型数据
        this.handleCloseImport()
        this.$emit('getUserMessageList')
      } else {
        this.$message.error(res.msg)
      }
    },
    // 关闭导入弹窗
    handleCloseImport() {
      this.importDialog = false
    },
    reasta13() {
      this.searchFormTimingTaskRecording.startTime = ''
      this.searchFormTimingTaskRecording.endTime = ''
      this.searchFormTimingTaskRecording.time = ''
      this.searchFormTimingTaskRecording.content = ''
      this.searchFormTimingTaskRecording.pageNum = 1

      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    handclose_99() {
      this.TimingTaskRecording = false
      this.searchFormTimingTaskRecording = {
        pageNum: 1,
        pageSize: 10,
        total: 1,
        startTime: '',
        endTime: '',
        time: '',
        content: ''
      }
    },
    openTimeTask_1(val) {
      if (this.activeName == 0) {
        this.cs_name = '灯光定时下发任务'
      } else if (this.activeName == 1) {
        this.cs_name = '滴灌定时下发任务'
      } else if (this.activeName == 2) {
        this.cs_name = '外风机定时下发任务'
      } else if (this.activeName == 3) {
        this.cs_name = '内风机定时下发任务'
      }
      this.TimingTaskRecording = true
      this.searchFormTimingTaskRecording.id = this.value
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    excel() {
      let form = {
        decisionId: this.value,
        type: this.activeName
      }
      this.$api.growthModel.exportGrowthModelDecisionSchedules(form).then(res => {
        if (res.code == 200) {
          window.open(res.data)
        }
      })
    },
    getGrowthModelDecisionScheduleHisDataSendList() {
      this.searchFormTimingTaskRecording.type = this.activeName
      this.$api.growthModel.getGrowthModelDecisionScheduleHisDataSendList(this.searchFormTimingTaskRecording).then(res => {
        if (res.code == 200) {
          res.data.map(item => {
            item.updateTime = moment(item.updateTime).format('YYYY-MM-DD HH:mm:ss')
          })
          this.TimingTaskRecordingtableData = res.data
          this.searchFormTimingTaskRecording.total = res.count
        }
      })
    },
    handleCurrentChange_2(currentPage) {
      this.searchFormTimingTaskRecording.pageNum = currentPage
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    getTime_1(val) {
      this.searchFormTimingTaskRecording.startTime = val[0]
      this.searchFormTimingTaskRecording.endTime = val[1]
      this.getGrowthModelDecisionScheduleHisDataSendList()
    },
    openAddit_() {
      this.addEditId = ''

      this.ruleFormTime = {
        decisionId: this.value,
        endTime: '',
        orderNum: '',
        startTime: '',
        type: this.activeName,
        weekTime: '',
        id: '',
        time: ''
      }
      this.extendIsDialog_ = true
    },
    updatabox(row) {
      this.addEditId = row
      this.ruleFormTime.id = row
      this.extendIsDialog_ = true
      this.getGrowthModelDecisionSchedule()
    },
    getGrowthModelDecisionSchedule() {
      this.$api.growthModel.getGrowthModelDecisionSchedule({ id: this.addEditId }).then(res => {
        if (res.code == 200) {
          res.data.time = [res.data.startTime, res.data.endTime]
          this.ruleFormTime = res.data
          console.log(this.ruleFormTime)
        }
      })
    },
    handleSaveExtend_Time() {
      this.$refs['ruleFormExtend'].validate(valid => {
        if (valid) {
          this.ruleFormTime.startTime = this.ruleFormTime.time[0]
          this.ruleFormTime.endTime = this.ruleFormTime.time[1]
          this.$api.growthModel.saveGrowthModelDecisionSchedule(this.ruleFormTime).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.handleCancelExtend()
              this.$parent.$parent.$parent.getUserMessageList()
            }
          })
        }
      })
    },
    delModelAlarmSettings(row) {
      this.$api.growthModel.delGrowthModelDecisionSchedule(row).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.$parent.$parent.$parent.getUserMessageList()
        }
      })
    },
    updateGrowthModelDecisionScheduleStatus(row) {
      this.$api.growthModel.updateGrowthModelDecisionScheduleStatus({ id: row }).then(res => {
        if (res.code == 200) {
          this.$message({
            type: 'success',
            message: res.msg
          })
          this.$parent.$parent.$parent.getUserMessageList()
        }
      })
    },
    // 取消
    handleCancelExtend() {
      this.$refs['ruleFormExtend'].resetFields()
      this.ruleFormExtend = {
        decisionId: this.value,
        num: ''
      }
      this.ruleFormTime = {
        decisionId: '',
        endTime: '',
        orderNum: '',
        startTime: '',
        type: '',
        weekTime: '',
        time: '',
        id: ''
      }
      this.extendIsDialog = false
      this.extendIsDialog_ = false
    },
    handleSaveExtend_A(type) {
      console.log(this.devicId_, 9898)
      if (this.devicId_ != 1) {
        const h = this.$createElement
        this.$msgbox({
          title: '注意:',
          message: h('p', null, [h('i', { style: 'color: teal' }, '当前运行模式非定时控制模式，请切换模式后再进行操作。')]),
          confirmButtonText: '确定',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {})
      } else {
        var that = this
        this.$confirm('是否下发？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isLoading = true
          // this.handleCancelExtend1()
          this.$api.growthModel.sendGrowthModelDecisionScheduleCmd({ id: this.value, type }).then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.isLoading = false
              that.$parent.$parent.$parent.getUserMessageList()
            }
          })
        })
      }
    },
    resetForm() {
      this.centerDialogVisible = false
      this.$refs['dialogformInline'].resetFields()
      this.dialogformInline = {
        //添加参数或者编辑参数
        username: '', //账号
        role: '', // 角色
        nink: '', // 昵称
        departId: '', // 组织机构
        password: '', //密码
        realName: '', //姓名
        gender: '', //性别
        mobile: '', //手机号
        email: '', //邮箱
        qq: '',
        roleID: ''
      }
    },
    // handleChange(e, form, thsAreaCode) {
    //   // thsAreaCode = this.form.areaCode    // 注意1：获取value值
    //   var thsAreaCode = this.$refs['cascaderAddr'].currentLabels //注意2： 获取label值
    //   console.log(thsAreaCode) // 注意3： 最终结果是个一维数组对象
    // },
    init() {
      this.getUserMessageList() //列表信息
      // this.getAllSysRole() //全部角色
      this.getDepartList() //获取组织机构
    },
    handleCurrentChange(currentPage) {
      //下一页
      this.currentPage = currentPage
      this.getUserMessageList() //查询列表
    },
    // 查询
    onSubmit() {
      this.currentPage = 1
      this.getUserMessageList() //查询列表
    },
    //列表信息
    getUserMessageList() {
      // this.$api.growthModel.getGrowthModelDecisionSchedules({ decisionId: this.timeId, type: this.activeName }).then((res) => {
      //   if (res.code == 200) {
      //     this.tableData = res.data
      //   }
      // })
    },
    //删除按钮
    del(id) {
      this.$confirm('是否删除？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(res => {
          this.$api.system.delfun(`/pc/sysUser/delSysUser`, id).then(res => {
            if (res.code == 200) {
              this.getUserMessageList()
              this.$message({
                type: 'success',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    add() {
      //添加
      this.dialogTitle = '添加用户'
      this.centerDialogVisible = true
      this.editTd = ''
      this.getDepartList()
    },
    handleClick(id, type) {
      if (type == 'edit') {
        this.dialogTitle = '编辑用户'
        this.centerDialogVisible = true
        this.editTd = id
        this.getUserDetails(id) //编辑详情

        this.getDepartList()
      } else if (type == 'frozen') {
        this.$confirm('是否冻结?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.setfrozen(id) //启动  冻结
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消冻结'
            })
          })
      } else if (type == 'enable') {
        this.$confirm('是否启用?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.setfrozen(id) //启动  冻结
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消启用'
            })
          })
      }
    },
    //重置
    usrReset() {
      this.formInline.user = ''
      this.formInline.nink = ''
      this.formInline.role = ''
      this.formInline.searchId = ''
      this.formInline.organization = ''
      this.getUserMessageList()
    },
    submitForm(formName, id) {
      // 提交表单
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.dialogTitle == '添加用户') {
            //为添加新用户
            this.newUsersData() // 新增
          } else {
            //为编辑dialogformInline
            this.newUsersData() //编辑
          }
        } else {
          return false
        }
      })
    },
    cancellation() {
      //弹框取消时
      this.centerDialogVisible = false
    },
    //添加用户是的接口 this.dialogformInline.departId
    newUsersData() {
      if (isNaN(this.dialogformInline.role)) {
        this.allSysRoleList.map((s, index) => {
          if (s.name === this.dialogformInline.role) {
            this.dialogformInline.role = this.allSysRoleList[index].id
          }
        })
      }
      if (isNaN(this.dialogformInline.departId)) {
        this.departList.map((s, index) => {
          if (s.name === this.dialogformInline.departId) {
            this.dialogformInline.departId = this.departList[index].id
          }
        })
      }
      this.loading = true //开启加载
      if (this.dialogformInline.password == this.pwd) {
        this.dialogformInline.password = this.dialogformInline.password
      } else {
        this.dialogformInline.password = this.$utils.calcuMD5(this.dialogformInline.password)
      }
      console.log(this.editTd)
      this.$api.system
        .newUsersData(
          this.dialogformInline.username, //账号
          this.dialogformInline.role, // 角色
          this.dialogformInline.nink, // 昵称
          this.dialogformInline.departId, // 组织机构
          this.dialogformInline.password, //密码
          this.dialogformInline.realName, //姓名
          (this.dialogformInline.gender = this.dialogformInline.gender),
          this.dialogformInline.mobile, //手机号
          this.dialogformInline.email, //邮箱
          this.dialogformInline.qq,
          0,
          this.editTd
        )
        .then(res => {
          if (res.code == 200) {
            this.loading = false //关闭加载
            this.formInline.organization = ''
            this.getUserMessageList() //刷新列表
            this.$message({ type: 'success', message: res.msg })
            this.resetForm()
            this.centerDialogVisible = false
          } else {
            this.loading = false //关闭加载
          }
        })
    },
    //编辑列表数据接口
    setUserMessageList() {
      this.loading = true //开启加载
      this.$api.system.setUserMessageList().then(res => {
        if (res.code == 200) {
          this.loading = false //关闭加载
          this.$message({ type: 'success', message: res.msg })
        } else {
          this.loading = false //关闭加载
        }
      })
    },
    //冻结接口 启动
    setfrozen(id) {
      this.$api.system.setfrozen(id).then(res => {
        if (res.code == 200) {
          this.getUserMessageList() ///
          this.$message({ type: 'success', message: res.msg })
        }
      })
    },
    //获取详情
    getUserDetails(id) {
      this.$api.system.getUserDetails(id).then(res => {
        if (res.code == 200) {
          this.dialogformInline.roleID = res.data.roleId
          this.dialogformInline.role = res.data.roleId
          this.dialogformInline.username = res.data.username
          this.dialogformInline.nink = res.data.nick
          this.pwd = res.data.password
          this.dialogformInline.departId = res.data.departId
          this.dialogformInline.password = res.data.password
          this.dialogformInline.realName = res.data.realName
          this.dialogformInline.gender = res.data.gender.toString()
          this.dialogformInline.mobile = res.data.mobile
          this.dialogformInline.email = res.data.email
          this.dialogformInline.qq = res.data.qq
          this.dialogformInline.id = res.data.id
        }
      })
    },
    //获取全部角色
    getAllSysRole() {
      this.$api.system
        .getAllSysRole()
        .then(res => {
          if (res.code == 200) {
            this.allSysRoleList = res.data //全部角色
          }
        })
        .catch(err => {
          this.$message.info(err)
        })
    },
    //组织机构
    getDepartList() {
      this.$api.system
        .getDepartList(
          0 //0为中国
        )
        .then(res => {
          if (res.code == 200) {
            this.departList = res.data
          }
        })
    },
    changeTreeItem(val) {
      this.formInline.organization = val[val.length - 1]
    },
    changeTreeItem2(val) {
      this.dialogformInline.departId = val[val.length - 1]
    },
    // 子账号
    handleChild(row) {
      this.$router.push({
        name: 'childManagement',
        query: { parentId: row.id }
      })
    }
  }
}
</script>
<style scope lang="scss">
@import '@/style/userManagementone.scss';

.th.is-leaf {
  border: 0 !important;
}
.a96 {
  display: flex;
  justify-content: space-between;
}
.flex {
  display: flex;
  align-items: center;
}
</style>
